import { useEffect, useState } from "react";
import api from '../../Axios'
const NewsFeed = () => {
  const [news, setNews] = useState([]);
  console.log(news);
  useEffect(() => {
    const fetchNews = async () => {
      const response = await api.get(`${process.env.REACT_APP_BASE_URL}/api/v1/news`);
      console.log(response,'rrrrr')
      setNews(response.data.newsList);
    };
    fetchNews();
  }, []);
  
//  const fetchNews = async () => {
//     try {
//       const data = await getNews();
//       setNewsList(data);
//     } catch (error) {
//       console.error("Failed to fetch news:", error);
//     }
//   };

  return (
    <div className="w-full max-w-md border border-gray-700 rounded-lg p-4 bg-white shadow-md">
      <h2 className="text-xl font-bold text-center underline text-gray-900 mb-3">
        📢 News & Updates
      </h2>
      <div className="h-48 overflow-hidden relative">
        <marquee direction="up" scrollamount="1" className="space-y-3">
          {news.length === 0 ? (
            <p className="text-center text-gray-600">No news available.</p>
          ) : (
            news.map((item) => (
              <p key={item.id} className="text-gray-800 border">
                {item.title}{" "}
                <a href={item.description} target="_blank" rel="noopener noreferrer" className="text-blue-500">
                  {item.description}
                </a>{" "}
                {item.pdf && (
                  
                   <a href={`https://collegebackend-e43r.onrender.com/${item.pdf}`} target="_blank" rel="noopener noreferrer" className="text-blue-500">View PDF</a>
                )}
              </p>
              
            ))
          )}
        </marquee>
      </div>
    </div>
  );
};

export default NewsFeed;
